
import type React from "react"
import { useCartStore } from "../../store/cart"
import { ShoppingCart } from "lucide-react"
import { useNavigate } from "react-router-dom"

const CartSummary: React.FC = () => {
  const { getTotalItems, getTotalPrice } = useCartStore()
  const navigate = useNavigate()

  const totalItems = getTotalItems()
  const totalPrice = getTotalPrice()

  if (totalItems === 0) return null

  return (
    <button
      type="button"
      onClick={() => navigate("/cart")}
      aria-label={`View cart: ${totalItems} ${totalItems === 1 ? "item" : "items"}, ₦${totalPrice.toLocaleString()}`}
      className="fixed bottom-6 right-6 z-sticky flex min-h-[44px] items-center gap-3 rounded-lg border border-border bg-background-card px-4 py-3 text-left shadow-md transition-colors duration-200 hover:bg-background-alt animate-fade-up"
    >
      <span className="relative flex h-9 w-9 items-center justify-center rounded-md bg-primary/10 text-primary">
        <ShoppingCart size={18} aria-hidden="true" />
        <span
          aria-hidden="true"
          className="absolute -right-1.5 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-sm bg-primary px-1 text-overline font-semibold leading-none text-white"
        >
          {totalItems}
        </span>
      </span>
      <span className="hidden sm:block">
        <span className="block text-caption text-text-secondary">
          {totalItems} {totalItems === 1 ? "item" : "items"}
        </span>
        <span className="block font-sans text-caption font-semibold text-text-primary">
          ₦{totalPrice.toLocaleString()}
        </span>
      </span>
      <span className="hidden text-caption font-medium text-primary md:block">View Cart</span>
    </button>
  )
}

export default CartSummary
